module.exports = __webpack_public_path__ + "img/hederImg.f5a93055.png";